module.exports = __webpack_public_path__ + "media/assets/images/layout/body-bg-toast-a7213c183e3c18d33e0b9833c03f9c57.png";